var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.33 0C26.06 0.1 26.8 0.18 27.53 0.32C31.47 1.1 34.7 2.97 36.88 6.42C37.94 8.09 38.54 9.94 38.88 11.93H32.72C32.33 11.05 32.02 10.17 31.57 9.37C30.33 7.2 28.4 5.99 25.97 5.56C24.26 5.26 22.56 5.34 20.91 5.9C18.56 6.7 16.99 8.35 15.97 10.55C14.93 12.8 14.71 15.21 14.74 17.66C14.74 18.34 14.93 18.8 15.48 19.26C18.29 21.59 21.06 23.96 23.85 26.32C24.6 26.96 25.34 27.63 26.09 28.27C26.21 28.37 26.43 28.43 26.57 28.39C29.8 27.62 32.3 24.87 32.77 21.59C32.79 21.44 32.82 21.3 32.85 21.13H39.01C38.51 26.46 35.93 30.33 31.05 32.66L38.82 39.94L38.72 40.05C25.44 30.02 12.78 19.24 0.719971 7.77L0.799971 7.67C2.08997 8.64 3.37997 9.59 4.64997 10.57C5.92997 11.55 7.18997 12.54 8.50997 13.57C8.57997 13.19 8.63997 12.85 8.70997 12.52C9.45997 8.76 11.18 5.57 14.2 3.15C16.55 1.28 19.28 0.36 22.26 0.09C22.44 0.07 22.62 0.03 22.8 0H25.33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.51,
    height: 40.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/c_logo.9ae5889affecfa02129edcf0af22907c.svg";
export { ForwardRef as ReactComponent };